module.exports = __webpack_public_path__ + "static/media/new-zephyr-lite.85d31344.png";